import { useState, useEffect } from 'react'

const Typewriter = ({ text, delay, delayNextWord, delayStartup }) => {
  const [currentText, setCurrentText] = useState('')
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    let timeout

    if (currentIndex < text.length) {
      timeout = setTimeout(() => {
        // get next character in text
        let char = text[currentIndex]
        if (char === ' ') {
          // sleep for next word
          setTimeout(() => {
            setCurrentText(prevText => prevText + char)
            setCurrentIndex(prevIndex => prevIndex + 1)
          }, delayNextWord)
        } else {
          // write next character
          setCurrentText(prevText => prevText + char)
          setCurrentIndex(prevIndex => prevIndex + 1)
        }
      }, currentIndex === 0 ? delayStartup : delay)
    }

    return () => clearTimeout(timeout)
  }, [currentIndex, delay, delayNextWord, delayStartup, text])

  return (<span>{currentText}</span>)
}

export default Typewriter